import React from "react";

export const ProcessTeams = React.createContext(null);
